var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBarsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 60",
    id: "bars_inline_svg__svg35"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "bars_inline_svg__defs15"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "bars_inline_svg__a",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    id: "bars_inline_svg__feOffset4"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b",
    id: "bars_inline_svg__feGaussianBlur6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    id: "bars_inline_svg__feFlood8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b",
    id: "bars_inline_svg__feComposite10",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "result1",
    id: "bars_inline_svg__feComposite12"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".bars_inline_svg__b{fill:none;stroke:#2261da;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-686.837 -2870.092)",
    id: "bars_inline_svg__g33"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(693 2876)",
    id: "bars_inline_svg__g31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bars_inline_svg__b",
    transform: "translate(3 51)",
    id: "bars_inline_svg__line21",
    d: "M0 0h48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bars_inline_svg__b",
    transform: "translate(3 3)",
    id: "bars_inline_svg__line23",
    d: "M0 0v48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bars_inline_svg__b",
    transform: "translate(27 10)",
    id: "bars_inline_svg__line25",
    d: "M0 0v34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bars_inline_svg__b",
    transform: "translate(38 18)",
    id: "bars_inline_svg__line27",
    d: "M0 0v26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bars_inline_svg__b",
    transform: "translate(16 27)",
    id: "bars_inline_svg__line29",
    d: "M0 0v17"
  })))));
}

export default SvgBarsinline;